<div class="table-container position-relative">
  <div class="table-responsive">
    <table (matSortChange)="tableSortChange($event)"
           [dataSource]="dataSource"
           class="mat-elevation-z8"
           mat-table
           matSort>
      @for (header of displayColumns; track $index) {
        <ng-container matColumnDef="{{header}}">
          @if (['event', 'icon', 'row_number', 'image', 'businesses'].includes(displayColumnTypes[$index])) {
            <th *matHeaderCellDef
                class="header-cell"
                mat-header-cell
                style="width: 150px!important;">
              <div>
                {{ header | translate }}
              </div>
            </th>
          } @else {
            <th *matHeaderCellDef
                mat-header-cell
                mat-sort-header>
              {{ header | translate }}
            </th>
          }
          <td *matCellDef="let element; let j = index"
              [attr.content]="header | translate"
              mat-cell>
            <div class="table-data-content">
              @if (['variable_event', 'event', 'icon', 'image'].includes(displayColumnTypes[$index])) {
                @if (displayColumnTypes[$index] === 'event') {
                  <mat-icon (click)="element[displayDataSources[$index]](j)"
                            [fontIcon]="displayDataSources[$index]"
                            style="color: #6c6c6c"/>
                } @else if (displayColumnTypes[$index] === 'icon') {
                  @if (getValue($index, j, element, displayDataSources[$index])?.split('-').length > 1) {
                    <mat-icon [fontIcon]="getValue($index, j, element, displayDataSources[$index]).split('-')[0]"
                              [ngStyle]="{'color': getValue($index, j, element, displayDataSources[$index]).split(getValue($index, j, element, displayDataSources[$index]).split('-')[0] + '-')[1]}"/>
                  }
                } @else if (displayColumnTypes[$index] === 'image') {
                  <img [src]="formatImage(getValue($index, j, element, displayDataSources[$index]))"
                       style="width: 50px">
                } @else if (displayColumnTypes[$index] === 'variable_event') {
                  <mat-radio-button (click)="element[displayColumns[$index]](j)"
                                    [name]="element[displayDataSources[$index]]"
                                    [value]="displayColumns[$index]">
                  </mat-radio-button>
                }
              } @else {
                @if (['string', 'boolean', 'business'].includes(displayColumnTypes[$index])) {
                  {{ getValue($index, j, element, displayDataSources[$index]) | onlinetranslate }}
                } @else  if (displayColumnTypes[$index].startsWith('status')) {
                  <span
                    [style.color]="element.StatusColor || getStatusColor(getValue($index, j, element, displayDataSources[$index]))">
                  {{ getValue($index, j, element, displayDataSources[$index]) | onlinetranslate }}
                </span>
                } @else if (displayColumnTypes[$index].startsWith('date')) {
                  {{ getValue($index, j, element, displayDataSources[$index]) | time: displayColumnTypes[$index].split('date:')[1] }}
                } @else if (['number', 'row_number', 'percent', 'price'].includes(displayColumnTypes[$index])) {
                  {{ numberAsCurrency(getValue($index, j, element, displayDataSources[$index])) }}{{ displayColumnTypes[$index] === 'percent' ? ' %' : '' }} {{ displayColumnTypes[$index] === 'price' ? ('Currency' | translate) : '' }}
                }
              }
            </div>
          </td>
        </ng-container>
      }
      <ng-container matColumnDef="description">
        <td *matFooterCellDef
            class="footer-cell"
            colspan="30"
            mat-footer-cell>
          <div class="d-lg-flex">
            <div class="col-12 d-flex justify-content-end">
              @if (tableProperties && hasPagination) {
                <mat-paginator (page)="tableProperties.pageChanged($event)"
                               [length]="tableProperties.pageLength"
                               [pageIndex]="tableProperties.offset"
                               [pageSizeOptions]="tableProperties.limitOptions"
                               [pageSize]="tableProperties.limit"
                               [showFirstLastButtons]="showFirstLastButtons"
                               id="pagination-class"
                ></mat-paginator>
              }
            </div>
          </div>
        </td>
      </ng-container>
      <tr *matHeaderRowDef="displayColumns"
          class="header-row"
          mat-header-row></tr>
      <tr (click)="onRowClicked(row)"
          *matRowDef="let row; columns: displayColumns;"
          [ngClass]="{'selected-row': isIncluded(row)}"
          class="data-row"
          mat-row></tr>
      <tr *matFooterRowDef="['description']"
          class="example-second-footer-row flex-wrap"
          mat-footer-row></tr>
    </table>
  </div>
</div>
